import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import Select from './Select';

const CountryField = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ countries, setCountries ] = useState([]);

	useEffect(() => {
		$.get('/v24/utils/getAllCountries', (res) => {
			const included_countries = props?.include ?? false;
			const excluded_countries = props?.exclude ?? false

			const include = (included_countries) ? included_countries.split(",") : [];
			const exclude = (excluded_countries) ? excluded_countries.split(",") : [];

			const tmp_countries = (include.length > 0) ? res.countries.filter((item) => (include.indexOf(item.k) !== -1)) : res.countries;

			const _countries = tmp_countries.filter((item) => (exclude.indexOf(item.k) == -1));
			_countries.unshift({ k:'', v:`-- ${i18n("Select")} --` });
			setCountries(_countries);
		}, 'JSON');
	}, []);

	return (
		<Select
			{...props}
			values={countries}
		/>
	)
};

export default injectIntl(CountryField);